module.exports = __webpack_public_path__ + "img/bep_logo_white.dc6faba6.png";